import { Menu, MenuProps, styled } from "@mui/material";

export const ActionMenu = styled((props: MenuProps) => (
  <Menu
    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    transformOrigin={{ vertical: "top", horizontal: "right" }}
    slotProps={{
      paper: {
        style: {
          width: "200px",
        },
      },
    }}
    {...props}
  />
))({
  "& .MuiPaper-root": {
    boxShadow: "0px 2px 12px rgba(0,0,0,0.1)",
  },
});
